module.exports = __webpack_public_path__ + "img/Flag_of_Samoa.69b52e9a.svg";